import { api } from "../api";

export const deleteWardRoundTemplate = async (wardRoundTemplateId: string): Promise<void> => {
  await api.services.wardRoundTemplates.deleteWardRoundTemplate(wardRoundTemplateId);
};
